import esquire from "@/types/clients/esquire";
import PostVatNumberRequest, { VatNumberStoreResult } from "@/types/clients/esquire/requests/post-vat-number-request";
import PostVatNumberPayload from "@/types/clients/esquire/payloads/post-vat-number-payload";

const postVatReq = new PostVatNumberRequest(esquire);

class VatApi {
  async validate(contractId: string, vatNumber: string): Promise<VatNumberStoreResult> {
    return await postVatReq.send(new PostVatNumberPayload(contractId, vatNumber.trim()));
  }
}

export default new VatApi();
